import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ResponsiveBaseComponent } from 'shared-lib';
import { ParkingAccessMode, ParkingEntryType, ParkingSpaceType, SortOrder } from '../../../api/gen';


export interface ParkingSpaceFilter {
  name?: string;
  type?: ParkingSpaceType;
  parkingZoneId?: string;
  parkingSpaceInfrastructureId?: string;
  sortBy?: string;
  sortOrder?: SortOrder;
  accessMode?: ParkingAccessMode;
  entryType?: ParkingEntryType;
}

@Component({
  selector: 'app-parking-spaces-filter',
  imports: [CommonModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    MatIconModule],
  templateUrl: './parking-spaces-filter.component.html',
  styleUrls: ['./parking-spaces-filter.component.scss']
})
export class ParkingSpacesFilterComponent extends ResponsiveBaseComponent {
  @Input() initialFilter: ParkingSpaceFilter = {};
  @Output() filterApplied = new EventEmitter<ParkingSpaceFilter>();

  private fb = inject(FormBuilder);
  private dialogRef = inject(MatDialogRef<ParkingSpacesFilterComponent>);
  private data: ParkingSpaceFilter = inject(MAT_DIALOG_DATA) || {};

  filterForm: FormGroup;

  parkingSpaceTypes = [
    { key: 'standard', value: ParkingSpaceType.Standard, label: 'Standard' }
  ];

  sortOrders = [
    { key: 'asc', value: SortOrder.Ascending, label: 'Ascending' },
    { key: 'desc', value: SortOrder.Descending, label: 'Descending' }
  ];

  sortFields = [
    { key: 'name', value: 'name', label: 'Name' },
    { key: 'type', value: 'type', label: 'Type' },
    { key: 'createdDate', value: 'createdDate', label: 'Created Date' },
    { key: 'modifiedDate', value: 'modifiedDate', label: 'Modified Date' }
  ];

  constructor() {
    super();

    this.filterForm = this.fb.group({
      name: [this.data?.name || ''],
      type: [this.data?.type || ''],
      parkingZoneId: [this.data?.parkingZoneId || ''],
      parkingSpaceInfrastructureId: [this.data?.parkingSpaceInfrastructureId || ''],
      sortBy: [this.data?.sortBy || ''],
      sortOrder: [this.data?.sortOrder || '']
    });
  }

  applyFilters(): void {
    const filterValues = this.filterForm.value;

    // Remove empty values
    const cleanedFilter: ParkingSpaceFilter = {};
    Object.keys(filterValues).forEach(key => {
      const value = filterValues[key];
      if (value !== null && value !== undefined && value !== '') {
        cleanedFilter[key as keyof ParkingSpaceFilter] = value;
      }
    });

    this.filterApplied.emit(cleanedFilter);
    this.dialogRef.close(cleanedFilter);
  }

  clearFilters(): void {
    this.filterForm.reset();
    const emptyFilter: ParkingSpaceFilter = {};
    this.filterApplied.emit(emptyFilter);
    this.dialogRef.close(emptyFilter);
  }
}
